import {
  Rectangle,
  Color,
} from "cesium";

/// /// 4次メッシュ3列の可視化・デフォルト倍率設定の追加・20230222 /////////////////////////
export function mesh4thRect(
  meshcode4th,
  h,
  c,
  dataname,
  pagedata,
  shikii1,
  shikii2,
  shikii3,
  shikii4,
  hanrei1_color,
  hanrei2_color,
  hanrei3_color,
  hanrei4_color,
  hanrei5_color,
  ratio,
  alpha,
  defaultratio,
  year1_nihonsokuchi
) {
  var strMeshcoe = String(meshcode4th);
  var p = parseInt(strMeshcoe.slice(0, 2));
  var u = parseInt(strMeshcoe.slice(2, 4));
  var q = parseInt(strMeshcoe.slice(4, 5));
  var v = parseInt(strMeshcoe.slice(5, 6));
  var r = parseInt(strMeshcoe.slice(6, 7));
  var w = parseInt(strMeshcoe.slice(7, 8));
  var m = parseInt(strMeshcoe.slice(8, 9));
  // var n = parseInt(meshcode.slice(9,10));

  var lat = 0;
  var lon = 0;
  var latc = 0;
  var lonc = 0;
  var lat_p = 0;
  var lon_p = 0;

  if(year1_nihonsokuchi>0){
    lat_p = p / 1.5 + q / 12 + r / 120 + (m > 2 ? 1 : 0) * 15/3600;
    lon_p = u + 100 + v * 0.125 + w * 0.0125 + (m%2 == 0 ? 1 : 0) * 22.5/3600;
    lat =  lat_p - 0.00010695 * lat_p + 0.000017464 * lon_p + 0.0046017;
    lon = lon_p - 0.000046038 * lat_p - 0.000083043 * lon_p + 0.01004;
    latc = lat + 0.008333333 / 4;
    lonc = lon + 0.0125 / 4;
  } else {
    lat = p / 1.5 + q / 12 + r / 120 + (m > 2 ? 1 : 0) * 15/3600;
    lon = u + 100 + v * 0.125 + w * 0.0125 + (m%2 == 0 ? 1 : 0) * 22.5/3600;
    latc = lat + 0.008333333 / 4;
    lonc = lon + 0.0125 / 4;
  }

  var alphatmp = alpha || 1;

  // var latc = latcpre.toPrecision(6)
  // var lonc = loncpre.toPrecision(6)

  var color1;
  if (c >= shikii1) {
    // console.log(c+"、"+shikii1);
    color1 = hanrei1_color;
    // color1 = "#67ADDF";
  } else if (c >= shikii2) {
    color1 = hanrei2_color;
  } else if (c >= shikii3) {
    // console.log(c+"、"+shikii3);
    color1 = hanrei3_color;
  } else if (c >= shikii4) {
    color1 = hanrei4_color;
  } else {
    // console.log(c+"、"+shikii4);
    color1 = hanrei5_color || hanrei4_color;
  }

  var ans_entities = {
    parent: dataname,
    // id:meshcode4th ,
    // description : "<p>"+meshcode4th+"</p><p>"+h+"</p><p>"+c+"</p>",
    name: lonc + "," + latc + "," + meshcode4th + "," + h + "," + c,
    rectangle: {
      coordinates: Rectangle.fromDegrees(
        lon,
        lat,
        lon + 0.0125/2,
        lat + 0.008333333/2
      ),
      height: 0,
      extrudedHeight: h * defaultratio * ratio,
      material: Color.fromCssColorString(color1).withAlpha(alphatmp),
      // material : Color.fromRgba( color_gbra )
      outline: true,
      outlineColor: "white",
      outlineWidth: 1,
      // shadows : ShadowMode.ENABLED
    },
  };
  return ans_entities;
}
/// ///////////////////////// 3次メッシュ3列の可視化 ///